import { render, staticRenderFns } from "./gasConfig.vue?vue&type=template&id=dc58cbf0&scoped=true&"
import script from "./gasConfig.vue?vue&type=script&lang=js&"
export * from "./gasConfig.vue?vue&type=script&lang=js&"
import style0 from "./gasConfig.vue?vue&type=style&index=0&id=dc58cbf0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc58cbf0",
  null
  
)

export default component.exports